/**
 * Validações do fluxo de conexão do Messenger (DEV4-5549).
 *
 * O resultado do login no Facebook volta ao SPA por `postMessage`, enviado pela
 * página `/fb/feedback` do legado (polichat-web-app). Essa página é servida no
 * mesmo host de onde o SPA pediu o link (`/fb/getlinklogin`), ou seja, a URL do
 * Laravel configurada para o SPA. O `link` desse resultado é depois aberto com
 * `window.open`, então nem a origem da mensagem nem o link podem ser aceitos às
 * cegas.
 */

function toHttpOrigin(url) {
  if (typeof url !== 'string' || url === '') return null;
  try {
    const { protocol, origin } = new URL(url);
    return protocol === 'https:' || protocol === 'http:' ? origin : null;
  } catch (e) {
    return null;
  }
}

/**
 * A origem do evento precisa ser exatamente a origem de uma das URLs do Laravel
 * conhecidas pelo SPA. Origem opaca ("null") e URLs que não são http(s) nunca
 * passam.
 *
 * @param {string} origin `event.origin` do MessageEvent
 * @param {Array<string|null|undefined>} laravelUrls URLs confiáveis do legado
 * @returns {boolean}
 */
export function isTrustedLaravelOrigin(origin, laravelUrls) {
  if (typeof origin !== 'string' || origin === '' || origin === 'null') {
    return false;
  }
  return (laravelUrls || []).map(toHttpOrigin).includes(origin);
}

/**
 * O botão "Conectar agora" / "Tentar novamente" só abre o diálogo OAuth do
 * Facebook. Qualquer outro esquema (`javascript:`, `data:`) ou host é recusado.
 *
 * @param {string} link
 * @returns {boolean}
 */
export function isSafeFacebookLink(link) {
  if (typeof link !== 'string') return false;
  let url;
  try {
    url = new URL(link);
  } catch (e) {
    return false;
  }
  return (
    url.protocol === 'https:' &&
    (url.hostname === 'facebook.com' || url.hostname.endsWith('.facebook.com'))
  );
}
